import { MessageBox } from 'element-ui';
import dateFns from 'date-fns';
import { delay } from '@/utils/etc';

export async function confirmAllWaitingCancel(allBookings, membershipSystem) {
  const bookingSystem = '대기';
  if (allBookings.length === 0) {
    return true;
  }

  const bookingListHTML = allBookings
    .map(booking => {
      return `
		<li>
            <span>- ${dateFns.format(booking.dt, 'YYYY년 M월 D일 HH:mm')}</span>
            <span>${booking.member_name} (${booking.course_name})</span>
		</li>`;
    })
    .join('');

  const bookingWarningHTML = `<p class="confirm-description__main">새로운 예약 확정 정책을 설정할 경우 아래의 내역은 자동으로 취소 처리됩니다. \
                                    각 수업 별 대기 리스트가 변동될 수 있으니 반드시 본 내용 숙지하고 진행해 주시길 바랍니다.</p>\
                                <p class="confirm-description__sub">진행 즉시 일괄적으로 대기 취소 푸시 알림이 전송되고 ${
                                  membershipSystem.long
                                }는 자동 복구됩니다.</p>
                                <ul class="confirm-booking">${bookingListHTML}</ul>`;

  try {
    await delay(500);
    await MessageBox.confirm(
      bookingWarningHTML,
      `이미 대기 내역이 있어 바로 수정이 불가합니다.`,
      {
        confirmButtonText: '확인',
        cancelButtonText: `모든 ${bookingSystem} 취소하고 정책 수정`,
        showClose: false,
        dangerouslyUseHTMLString: true,
        customClass: 'fifl-message-box',
        confirmButtonClass: 'gray',
        cancelButtonClass: 'white',
        closeOnPressEscape: false,
        closeOnClickModal: false
      }
    );

    return false;
  } catch (err) {
    return true;
  }
}
